<nz-card [nzTitle]="'ACCOUNT_SETTINGS.BILLING.TITLE' | translate">
  <nz-spin [nzSpinning]="isLoading">
    <p class="subtitle">{{ 'ACCOUNT_SETTINGS.BILLING.SUBTITLE' | translate }}</p>

    <nz-empty
      *ngIf="paidPlanRequired && !pendingUpgradeInfo"
      [nzNotFoundContent]="'ACCOUNT_SETTINGS.BILLING.PAID_PLAN_REQUIRED_TITLE' | translate">
      <div nz-empty-footer>{{ 'ACCOUNT_SETTINGS.BILLING.PAID_PLAN_REQUIRED_DESCRIPTION' | translate }}</div>
    </nz-empty>

    <nz-alert
      *ngIf="pendingUpgradeInfo"
      nzType="info"
      nzShowIcon
      [nzMessage]="pendingActivationText"
      class="billing-pending-alert"
    ></nz-alert>

    <nz-empty
      *ngIf="!paidPlanRequired && !hasDocuments"
      [nzNotFoundContent]="'ACCOUNT_SETTINGS.BILLING.EMPTY_TITLE' | translate">
      <div nz-empty-footer>{{ 'ACCOUNT_SETTINGS.BILLING.EMPTY_DESCRIPTION' | translate }}</div>
    </nz-empty>

    <div *ngIf="!paidPlanRequired && hasDocuments" class="billing-groups">
      <section *ngFor="let group of documentsByYear; trackBy: trackBillingDocumentGroup" class="billing-group">
        <h3>{{ group.year }}</h3>
        <nz-list nzBordered>
          <nz-list-item *ngFor="let document of group.documents; trackBy: trackBillingDocument" class="billing-item">
            <div class="billing-item__content">
              <div class="billing-item__header">
                <strong class="billing-item__title">{{ document.title }}</strong>
                <div class="tags">
                  <nz-tag [nzColor]="document.type === 'contract' ? 'geekblue' : 'purple'">
                    {{ ('ACCOUNT_SETTINGS.BILLING.' + document.type.toUpperCase()) | translate }}
                  </nz-tag>
                  <nz-tag [nzColor]="statusColor(document.status)">
                    {{ ('BILLING.STATUS.' + document.status.toUpperCase()) | translate }}
                  </nz-tag>
                </div>
              </div>
              <div class="billing-item__details">
                <span *ngIf="document.documentNumber">{{ 'ACCOUNT_SETTINGS.BILLING.DOCUMENT_NUMBER' | translate }}: {{ document.documentNumber }}</span>
                <span *ngIf="document.amountGross">{{ 'ACCOUNT_SETTINGS.BILLING.AMOUNT' | translate }}: {{ formatBillingAmount(document.amountGross, document.currency) }}</span>
                <span *ngIf="document.type === 'contract' && document.contractStartDate">
                  {{ 'ADMIN_DASHBOARD.TABLE.CONTRACT_START' | translate }}: {{ formatBillingDate(document.contractStartDate) }}
                </span>
                <span *ngIf="document.type === 'invoice' && document.issueDate">{{ 'ACCOUNT_SETTINGS.BILLING.ISSUE_DATE' | translate }}: {{ formatBillingDate(document.issueDate) }}</span>
                <span *ngIf="document.type === 'invoice' && document.dueDate">{{ 'ACCOUNT_SETTINGS.BILLING.DUE_DATE' | translate }}: {{ formatBillingDate(document.dueDate) }}</span>
                <span *ngIf="document.fileName" class="billing-item__file-name">{{ document.fileName }}</span>
              </div>
            </div>
            <div class="billing-item__actions">
              <button
                nz-button
                nzType="default"
                type="button"
                [disabled]="document.migratedWithoutFile || !document.hasFile"
                (click)="download(document)">
                {{ document.migratedWithoutFile || !document.hasFile ? ('ACCOUNT_SETTINGS.BILLING.NO_FILE' | translate) : ('ACCOUNT_SETTINGS.BILLING.DOWNLOAD' | translate) }}
              </button>
            </div>
          </nz-list-item>
        </nz-list>
      </section>
    </div>
  </nz-spin>
</nz-card>
